import axios from 'axios'
import { getToken } from './tokenManager'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  withCredentials: true,
  timeout: Number(import.meta.env.VITE_API_TIMEOUT_MS || 30000),
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to attach token from tokenManager
api.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      console.log(`[API v2] Attaching Bearer token: ${token.substring(0, 8)}...`)
      config.headers.Authorization = `Bearer ${token}`
    } else if (!config.skipAuthRedirect && !config.url?.includes('/auth/login')) {
      console.debug('[API v2] No auth token available for request:', config.url)
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor to handle errors (dynamic import store only on error)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status
    const isAuthRequest = error.config?.url?.includes('/auth/login') || error.config?.url?.includes('/auth/me')
    
    if (status === 401 && !error.config?.skipAuthRedirect && !isAuthRequest) {
      const { useUserStore } = await import('../stores/userStore')
      const userStore = useUserStore()
      userStore.clearSession()
      
      const path = window.location.pathname.replace(/\/$/, '')
      const isAuthPage = ['/login', '/admin-login', '/signup', '/auth-callback'].includes(path)
      
      console.warn(`[API] 401 Unauthorized at ${error.config?.url}. Current path: ${path}. isAuthPage: ${isAuthPage}`)
      
      if (!isAuthPage) {
        console.log('[API] Redirecting to /login')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
